// Third-party imports
import $ from 'jquery';

// Local imports

export function buttonStateHandler() {
    let variantValue = $('.js-variantID-hook').val();
    let userQuantity = $('.js-quantityIncrementer-counter').val();

    if (variantValue && typeof userQuantity !== 'undefined') {
        setTimeout(() => {
            if (checkIfQuantity()) {
                addToCartButtonIsDisabled(false);
            } else {
                addToCartButtonIsDisabled(true);
            }
            updateAddGiftButtonLabel();
        });
    } else {
        if (checkIfMonthly()) {
            addToCartButtonIsDisabled(false);
        } else {
            addToCartButtonIsDisabled(true);
            updateAddGiftButtonLabel();
        }
    }
}
function checkIfMonthly() {
    let isMonthly = $('#product-data').data('product_ismonthly');
    return isMonthly;
}

function checkIfQuantity() {
    let userQuantity = $('.js-quantityIncrementer-counter').val();
    let userValue = parseInt(userQuantity);
    let quantityHook = $('.js-quantity-hook');
    let maxQuantityData = quantityHook.data('maxQuantity');
    let hasQuantity = maxQuantityData !== 'doesNotApply';

    if (hasQuantity && typeof userQuantity !== 'undefined') {
        let maxQuantity = parseInt(maxQuantityData);
        return userValue > 0 && userValue <= maxQuantity && !isNaN(userValue);
    } else {
        // If we're here, then the variant's inventory is not being tracked,
        // i.e. maxQuantityData == "doesNotApply". But we still want to evaluate
        // if the user value is valid, i.e. a number great than 0
        return !isNaN(userValue) && userValue > 0;
    }
}

function addToCartButtonIsDisabled(bool) {
    let addToCartButton = $('#to_cart');
    if (bool) {
        if (!addToCartButton.hasClass('button--disabled')) {
            addToCartButton.addClass('button--disabled');
            addToCartButton.attr('tabindex', '-1');
        }
    } else {
        if (addToCartButton.hasClass('button--disabled')) {
            addToCartButton.removeClass('button--disabled');
            addToCartButton.attr('tabindex', '0');
        }
    }
}

export function updateAddGiftButtonLabel() {
    let add_button = $('#to_cart');
    if (!add_button) {
        return;
    }

    let addButtonLabel = $('#addButtonLabel');
    if (!addButtonLabel) {
        return;
    }

    let buttonLabel = $('.js-addToBasketText-hook').val();
    let quantityHook = $('.js-quantity-hook');
    let userQuantity = $('.js-quantityIncrementer-counter').val();
    let isQuantity = typeof userQuantity !== 'undefined';
    // Inventory sold out
    if (quantityHook.data('maxQuantity') === 0 && isQuantity) {
        buttonLabel = $('.js-soldOutText-hook').val();
        addToCartButtonIsDisabled(true);
    } else if (getVariantInCartElement()) {
        buttonLabel = add_button.data('updateProductBtnText');
        add_button.attr('aria-label', buttonLabel);
        // The following only applies to OGC re-designed pages.
        // we wrap this functionality inside an IF statement with an element
        // that only appears on the re-designed product page.
        let viewButton = $('#view_basket');
        if (viewButton.length) {
            if ($('.qtyChange-hook').is(':hidden')) {
                viewButton.removeClass('button--removed');
                add_button.addClass('button--removed');
            } else {
                viewButton.addClass('button--removed');
                add_button.removeClass('button--removed');
            }
        }
    }
    addButtonLabel.html(buttonLabel);
}

function getVariantInCartElement() {
    let variantIDBeingPosted = $('.js-variantID-hook').val();
    let elementID = `#variant_id_${variantIDBeingPosted}`;
    let variantInCartElement = $(elementID);
    return variantInCartElement.length > 0;
}
